import React = require('react');
import { SignInErrorMessageMapper } from '~src/authentication/services/SignInErrorMessageMapper';
import { KbArticleLink } from '../KbArticleLink';

export interface LoginErrorMessageProps {
    errorCode?: number;
}

export function LoginErrorMessage(props: LoginErrorMessageProps) {
    if (!props.errorCode) {
        return null;
    }

    const followUpMessage = SignInErrorMessageMapper.getFollowUpActionMessageFor(props.errorCode);
    return <div className={'tb-login-msg-container'}>
        <div className={'tb-login-msg tb-login-error'} tb-test-id="message-failure" role="alert">
            <div>{SignInErrorMessageMapper.getErrorMessageFor(props.errorCode)}</div>
            {followUpMessage && <div>{followUpMessage}</div>}
            <KbArticleLink pageId={SignInErrorMessageMapper.getKbArticleIdFor(props.errorCode)} />
        </div>
    </div>;
}
